module.exports = __webpack_public_path__ + "assets/img/object-new.2f5ee915.svg";